import type { MaybeRef } from "vue"
import type { ServerResponseV1 } from "@/http"
import type { ISlideshowConfigResponse } from "@/types"
import { useQuery } from "@tanstack/vue-query"
import { toValue } from "vue"
import { v1 } from "@/axios"
import { SlideshowConfig } from "@/models"

export async function getSlideshowConfig(id: string, eventVaultId: number) {
  const response = await v1.get<ServerResponseV1<ISlideshowConfigResponse>>(`/${eventVaultId}/slideshow/${id}`)

  return SlideshowConfig.fromResponse(response.data.data)
}

export const GET_SLIDESHOW_CONFIG = "getSlideshowConfig"

export function useGetSlideshowConfig(id?: MaybeRef<string | undefined>, eventVaultId?: MaybeRef<number | undefined>) {
  return useQuery({
    queryKey: [GET_SLIDESHOW_CONFIG, id, eventVaultId],
    queryFn: () => getSlideshowConfig(toValue(id)!, toValue(eventVaultId)!),
    retry: false,
    enabled: !!toValue(id) && !!toValue(eventVaultId),
  })
}
